import { main } from "../output/Main/index";

main();
